import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data52 from '../../data/data52.json'
import { Carousel, Image } from 'antd';
import banner1 from '../../static/banner1.png'
import banner2 from '../../static/banner2.png'
import ArticleList from '../../Components/ArticleList';
const HappyChina: React.FC = () => {
    const history = useHistory();


    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>无郁中国行</h1>
                {/* 页面内容将在这里添加 */}
                <div className="intro-container" >
                    <div className="intro-text" >
                        <p>无郁中国行2021年项目支出1300000元，2022年项目支出800000元；2023年项目支出110万元。无郁中国行是面向全国各城市的郁友进行抑郁康复有方法的公益科普活动，通过线下心理健康及抑郁科普活动，让更多的人了解心理健康标准，学会心理自救和互助。项目通过线上活动【和你有约父母课堂】、【心理健康视频号直播间】开展线上全国公益心理健康科普活动；目前无郁中国行已走遍了全国大小城市乡镇，所到之处，受到了广大郁友们的热烈欢迎！</p>
                    </div>
                    <div className="intro-carousel" >
                        <Carousel autoplay>
                            <div>
                                <Image src={banner1} alt="轮播图1" />
                            </div>
                            <div>
                                <Image src={banner2} alt="轮播图1" />
                            </div>
                        </Carousel>
                    </div>
                </div>
                <ArticleList dataId="52" data={data52 as any} />
            </div>
        } />
    );
};

export default HappyChina;